import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import './ActionButtons.scss';
import useAction from './useAction';

const makeActionButton = (action, opts) => {
  const { useLabel = false } = opts;
  const Component = action.Button || (useLabel ? Button : IconButton);
  const options = opts.objectProp || opts.getObject ? opts : { ...opts, objectProp: 'row' };

  const ActionButton = (props) => {
    const { tooltip, Icon, ariaLabel, label, actionId, onClick, url, disabled } = useAction(action, props, options);
    let content = (
      <Component
        aria-label={action.getLink ? undefined : ariaLabel}
        onClick={action.getLink ? undefined : onClick}
        className="grb-table-icon-button"
        id={action.getLink ? undefined : actionId}
        variant={useLabel ? 'outlined' : undefined}
        disabled={disabled}
      >
        {!!Icon && <Icon className={useLabel && label ? 'grb-left-icon' : undefined} />}
        {useLabel && label}
      </Component>
    );
    if (action.getLink) {
      content = (
        <a
          href={url}
          download={action.download}
          aria-label={ariaLabel}
          id={actionId}
        >
          {content}
        </a>
      );
    }
    if (tooltip) {
      return (
        <Tooltip title={tooltip}>
          {content}
        </Tooltip>
      );
    }
    return content;
  };

  ActionButton.propTypes = {
    object: PropTypes.shape({}),
  };

  ActionButton.defaultProps = {
    object: undefined,
  };

  return ActionButton;
};

const ActionButtons = (actions, buttons, options) => {
  const keys = [];
  const Buttons = buttons.map((actionName) => {
    const action = actions[actionName];
    if (!action) {
      console.error('No action defined with name ', actionName);
      return null;
    }
    keys.push(actionName);
    return makeActionButton(action, options);
  }).filter(x => x);

  return (props) => (
    <React.Fragment>
      {Buttons.map((Comp, i) => (
        <Comp {...props} key={keys[i]} />
      ))}
    </React.Fragment>
  );
};

export { makeActionButton as default, ActionButtons };
